import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "design-system/molecules/Select"
import { FormDescription, FormLabel } from "design-system/organisms/Form"
import { UpdateCampaignSchemaFrontend } from "modules/campaigns/hooks/useCampaignForm"
import { useLanguageOptions } from "modules/shared/hooks/useLanguageLabel"
import { useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { z } from "zod"

type Props = {
  isDisabled: boolean
}

const NONE_VALUE = "__none__"

export function DefaultLanguageSelect({ isDisabled }: Props) {
  const { t } = useTranslation()
  const languageOptions = useLanguageOptions()
  const form = useFormContext<z.infer<typeof UpdateCampaignSchemaFrontend>>()
  const value = form.watch("defaultLanguage") ?? null

  return (
    <div className="flex flex-col gap-2">
      <FormLabel>{t("campaigns.channel.defaultLanguage.label")}</FormLabel>
      <Select
        value={value ?? NONE_VALUE}
        onValueChange={(next) => {
          const selected = next === NONE_VALUE ? null : next
          form.setValue("defaultLanguage", selected, { shouldDirty: true })
        }}
        disabled={isDisabled}
      >
        <SelectTrigger className="min-w-44">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE_VALUE}>{t("campaigns.channel.defaultLanguage.none")}</SelectItem>
          {languageOptions.map(({ value: langValue, label }) => (
            <SelectItem key={langValue} value={langValue}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <FormDescription>{t("campaigns.channel.defaultLanguage.description")}</FormDescription>
    </div>
  )
}
